// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"387":"6ba369c3","984":"1ec8f406"}[chunkId] + ".chunk.js";
};